import type React from "react";
import { forwardRef } from "react";
import { Badge } from "../Badge";

interface CounterBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  customColor?: string;
}

export const CounterBadge = forwardRef(function CounterBadge(
  { size = 20, customColor, ...props }: CounterBadgeProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <Badge
      variant="counter"
      size={size}
      customColor={customColor}
      ref={ref as React.Ref<HTMLSpanElement>}
      {...(props as React.HTMLAttributes<HTMLSpanElement>)}
    />
  );
});

CounterBadge.displayName = "CounterBadge";
